import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { withBase } from '../config/api'
import { primaryButtonStyle } from '../styles/buttonStyles'
import {
  footerModalActionsStyle,
  footerModalBoxStyle,
  footerModalOverlayStyle
} from '../styles/footerModalStyles'

const COMPANY_FALLBACK = {
  name: 'EnerqiQ Net OÜ',
  address: 'Sepapaja tn 6',
  city: 'Tallinn',
  zip: '11415',
  country: 'Estonia',
  ico: '17553401',
  registration: 'Estonian Commercial Register',
  support_email: 'support@enerqiq.net',
  info_email: 'support@enerqiq.net',
  phone: ''
}

const VOPModal = ({ open, onClose, openedFrom }) => {
  const { t } = useTranslation()
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)
  const [company, setCompany] = useState(COMPANY_FALLBACK)

  useEffect(() => {
    if (!open) return

    const controller = new AbortController()

    const loadCompany = async () => {
      try {
        const response = await fetch(withBase('/company/about'), {
          signal: controller.signal
        })

        if (!response.ok) {
          throw new Error('company-load-failed')
        }

        const data = await response.json()

        const validCompanyData = Object.fromEntries(
          Object.entries(data || {}).filter(([, value]) => {
            return (
              value !== null &&
              value !== undefined &&
              String(value).trim() !== ''
            )
          })
        )

        setCompany({
          ...COMPANY_FALLBACK,
          ...validCompanyData
        })
      } catch (error) {
        if (error.name !== 'AbortError') {
          setCompany(COMPANY_FALLBACK)
        }
      }
    }

    loadCompany()

    return () => {
      controller.abort()
    }
  }, [open])

  if (!open) return null

  const vop = t('VOP', { returnObjects: true })

  const countryValue = String(company.country || '').trim()

  const countryName = /^[A-Z]{2}$/.test(countryValue)
    ? t(countryValue, {
        defaultValue: countryValue
      })
    : countryValue

  const companyAddress = [
    company.address,
    [company.zip, company.city].filter(Boolean).join(' '),
    countryName
  ]
    .filter(Boolean)
    .join(', ')

  const replaceCompanyVariables = text => {
    if (typeof text !== 'string') return ''

    const values = {
      COMPANY_NAME: company.name,
      COMPANY_ADDRESS: companyAddress,
      COMPANY_ICO: company.ico,
      COMPANY_REGISTRATION: company.registration,
      COMPANY_SUPPORT_EMAIL: company.support_email,
      COMPANY_INFO_EMAIL: company.info_email,
      COMPANY_PHONE: company.phone
    }

    return Object.entries(values).reduce(
      (result, [key, value]) =>
        result.replaceAll(`{{${key}}}`, value || ''),
      text
    )
  }

  const isRegistrationVOP =
    openedFrom === 'checkbox' || openedFrom === 'link'

  return (
    <>
      <div
        onClick={() => {
          if (isRegistrationVOP) return
          onClose()
        }}
        style={footerModalOverlayStyle({ zIndex: 4500 })}
      />

      <div
        style={footerModalBoxStyle({ zIndex: 4600 })}
      >
        <div
          style={{
            marginBottom: 8,
            fontWeight: 'bold',
            fontSize: 24
          }}
        >
          {vop.TITLE}
        </div>

        {vop.INTRO && (
          <div
            style={{
              marginBottom: 12,
              fontSize: 17
            }}
          >
            {replaceCompanyVariables(vop.INTRO)}
          </div>
        )}

        {Object.keys(vop)
          .filter(k => k.endsWith('_TITLE'))
          .map(k => {
            const base = k.replace('_TITLE', '')

            return (
              <div
                key={k}
                style={{ marginBottom: 12 }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 18
                  }}
                >
                  {replaceCompanyVariables(
                    vop[`${base}_TITLE`]
                  )}
                </div>

                <div
                  style={{
                    whiteSpace: 'pre-line',
                    fontSize: 16
                  }}
                  dangerouslySetInnerHTML={{
                    __html: replaceCompanyVariables(
                      vop[`${base}_TEXT`]
                    )
                      .replace(
                        /\*\*(.*?)\*\*/g,
                        '<strong>$1</strong>'
                      )
                      .replace(/\n/g, '<br />')
                  }}
                />
              </div>
            )
          })}

        <div style={footerModalActionsStyle}>
          <button
            onClick={onClose}
            style={primaryButtonStyle(
              pressedBtn,
              'vop-close',
              hoverBtn === 'vop-close'
            )}
            onMouseEnter={() =>
              setHoverBtn('vop-close')
            }
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() =>
              setPressedBtn('vop-close')
            }
            onMouseUp={() =>
              setPressedBtn(null)
            }
          >
            {isRegistrationVOP
              ? t('AGREE_VOP')
              : t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default VOPModal